export default "__VITE_ASSET__DArAWWbA__"